<template>
    <div class="template-number-widget">
        <input type="number" :placeholder="placeholder" :value="value" @keyup="onNumberKeyup" @change="onNumberChange"
            @keydown="onNumberKeydown" :max="max" :min="min">
    </div>
</template>
<script>
import { eventBus } from "@/main";
export default {
    name: "editor-property",
    components: {

    },
    props: {
        placeholder: {
            type: String,
            default: "",
        },
        value: {
            type: Number,
            default: 1,
        },
        max: {
            type: Number,
            default: 9999999
        },
        min: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
        };
    },

    mounted() {
        let vm = this;

    },
    methods: {
        onNumberKeyup({ target }) {
            let vm = this;
            vm.$emit("input", parseInt(target.value));
        },
        onNumberChange({ target }) {
            let vm = this;
            vm.$emit("input", parseInt(target.value));
        },
        onNumberKeydown({ target }) {
            let vm = this;
            vm.$emit("input", parseInt(target.value));
        },
    },
};
</script>
  
<style lang="scss" scoped>
$assets: "~@/assets";

.template-number-widget {
    display: flex;
    position: relative;
    width: max-content;

    input {
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        height: 30px;
        width: 27px;
        border: 1px solid #e9e9e9;
        padding: 0px 10px;
        background-color: #ffffff;
        border-radius: 5px;
        padding: 0px;
        padding-left: 6px;
        text-align: center;

        &:focus {
            outline: none;
        }

        // hide arrows
        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }
    }

    &.no-border {
        input {
            border: none;
        }
    }
}
</style>